import React__default from 'react';

const Margin = (props) => React__default.createElement("div", { style: { margin: props.margin }, "data-zds": true }, props.children);

export { Margin };
//# sourceMappingURL=Margin.es.js.map
